<p-toast></p-toast>

<ng-container *ngIf="display === 'dialog'">
    <!-- Button to open the list -->
    <button pButton label="Incidents" type="button" (click)="showListDialog()" icon="pi pi-shield" class="mr-2"
        style="position: relative;" severity="danger">
        <p-badge [value]="getOpenIncidentCount()" severity="warn"
            [style]="{'position': 'absolute', 'top': '0', 'right': '0'}"></p-badge>
    </button>

    <!-- Main Dialog for listing incidents -->
    <p-dialog [(visible)]="listDialogVisible" [modal]="true" [style]="{width: '90vw'}" [draggable]="false"
        [resizable]="false">
        <ng-template pTemplate="header">
            <div class="flex align-items-center justify-content-between w-full">
                <div class="flex align-items-center">
                    <i class="pi pi-shield text-2xl mr-2"></i>
                    <h3 class="m-0">Incident Management</h3>
                    <p-badge [value]="getOpenIncidentCount()" severity="danger" class="ml-2"></p-badge>
                </div>
                <div class="flex align-items-center gap-2">
                    <p-selectButton [options]="filterOptions" [(ngModel)]="filter" optionLabel="label"
                        optionValue="value" (onChange)="loadIncidents()"></p-selectButton>
                    <p-button label="New Incident" icon="pi pi-plus" (click)="openNewIncidentDialog()"
                        class="mr-2"></p-button>
                </div>
            </div>
        </ng-template>
        <ng-container *ngTemplateOutlet="incidentContent"></ng-container>
        <ng-template pTemplate="footer">
            <p-button icon="pi pi-times" (click)="listDialogVisible = false" label="Close"
                styleClass="p-button-text"></p-button>
        </ng-template>
    </p-dialog>
</ng-container>

<div class="card" *ngIf="display === 'inline'">
    <div class="flex align-items-center justify-content-between w-full mb-3">
        <div class="flex align-items-center justify-content-between w-full">
            <div class="flex align-items-center">
                <i class="pi pi-shield text-2xl mr-2"></i>
                <h3 class="m-0">Incident Management</h3>
                <p-badge [value]="getOpenIncidentCount()" severity="danger" class="ml-2"></p-badge>
            </div>
            <div class="flex align-items-center gap-2">
                <p-selectButton [options]="filterOptions" [(ngModel)]="filter" optionLabel="label" optionValue="value"
                    (onChange)="loadIncidents()"></p-selectButton>
                <p-button label="New Incident" icon="pi pi-plus" (click)="openNewIncidentDialog()"
                    class="mr-2"></p-button>
            </div>
        </div>
    </div>
    <ng-container *ngTemplateOutlet="incidentContent"></ng-container>
</div>

<ng-template #incidentContent>
    <p-table #dt [value]="incidents" [lazy]="true" (onLazyLoad)="loadIncidents($event)" [paginator]="true" [rows]="25"
        [totalRecords]="totalRecords" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped"
        responsiveLayout="scroll">
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="title">Title
                    <p-sortIcon field="title"></p-sortIcon>
                </th>
                <th pSortableColumn="resource.resourceName">Linked To <p-sortIcon
                        field="resource.resourceName"></p-sortIcon></th>
                <th pSortableColumn="reportedBy.fullName">Reported By <p-sortIcon
                        field="reportedBy.fullName"></p-sortIcon></th>
                <th pSortableColumn="assignedTo.fullName">Assigned To <p-sortIcon
                        field="assignedTo.fullName"></p-sortIcon></th>
                <th pSortableColumn="priority">Priority <p-sortIcon field="priority"></p-sortIcon></th>
                <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
                <th style="width: 8rem">Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-incident>
            <tr>
                <td>{{ incident.title }}</td>
                <td>{{ incident.resource?.resourceName }} #{{ incident.linkedObjectId }}</td>
                <td>
                    <div class="flex align-items-center">
                        <p-avatar [image]="incident.reportedBy.profilePictureUrl || 'assets/manager.png'"
                            shape="circle" class="mr-2"></p-avatar>
                        <span>{{ incident.reportedBy.fullName }}</span>
                    </div>
                </td>
                <td>
                    <div *ngIf="incident.assignedTo" class="flex align-items-center">
                        <p-avatar [image]="incident.assignedTo.profilePictureUrl || 'assets/default-avatar.png'"
                            shape="circle" class="mr-2"></p-avatar>
                        <span>{{ incident.assignedTo.fullName }}</span>
                    </div>
                    <span *ngIf="!incident.assignedTo">Unassigned</span>
                </td>
                <td>
                    <p-tag [value]="incident.priority" [severity]="getPrioritySeverity(incident.priority)"></p-tag>
                </td>
                <td>
                    <p-tag [value]="incident.status" [severity]="getStatusSeverity(incident.status)"></p-tag>
                </td>
                <td>
                    <button pButton pRipple type="button" label="Details" icon="pi pi-search" class="p-button-text"
                        (click)="openIncidentDetails(incident)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7" class="text-center p-4">No incidents found.</td>
            </tr>
        </ng-template>
    </p-table>
</ng-template>

<!-- Dialog for creating a new incident -->
<p-dialog header="Create New Incident" [(visible)]="incidentFormDialogVisible" [modal]="true" [style]="{width: '40vw'}"
    (onHide)="incidentForm.reset()">
    <form [formGroup]="incidentForm" (ngSubmit)="saveNewIncident()" class="p-fluid grid formgrid">
        <div class="field col-12">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-tag"></i></p-inputgroup-addon>
                <p-iftalabel><input id="title" pInputText formControlName="title"><label
                        for="title">Title</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-12">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-align-left"></i></p-inputgroup-addon>
                <p-iftalabel><textarea id="description" pInputTextarea formControlName="description" rows="3"
                        [style]="{'width': '100%'}"></textarea><label
                        for="description">Description</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-6">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-sitemap"></i></p-inputgroup-addon>
                <p-iftalabel><p-dropdown inputId="resource" [options]="resourceList" formControlName="resource"
                        optionLabel="resourceName" placeholder="Select Type" styleClass="w-full"
                        [appendTo]="'body'"></p-dropdown><label for="resource">Linked Object Type</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-6">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
                <p-iftalabel><input id="linkedObjectId" pInputText formControlName="linkedObjectId"><label
                        for="linkedObjectId">Linked Object ID</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-6">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-flag"></i></p-inputgroup-addon>
                <p-iftalabel><p-dropdown inputId="priority" [options]="priorities" formControlName="priority"
                        styleClass="w-full" [appendTo]="'body'"></p-dropdown><label
                        for="priority">Priority</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-6">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-user"></i></p-inputgroup-addon>
                <p-iftalabel><p-dropdown inputId="assignedTo" [options]="users" formControlName="assignedTo"
                        optionLabel="fullName" optionValue="id" [showClear]="true" styleClass="w-full"
                        [appendTo]="'body'"></p-dropdown><label for="assignedTo">Assign To</label></p-iftalabel>
            </p-inputgroup>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" (click)="incidentFormDialogVisible = false"
            styleClass="p-button-text"></p-button>
        <p-button label="Create Incident" icon="pi pi-check" (click)="saveNewIncident()"
            [disabled]="incidentForm.invalid"></p-button>
    </ng-template>
</p-dialog>

<!-- Dialog for viewing/editing incident details -->
<p-dialog header="Incident Details" [(visible)]="incidentDetailsDialogVisible" [modal]="true" [style]="{width: '50vw'}"
    *ngIf="selectedIncident">
    <div class="p-fluid grid">
        <div class="col-12">
            <h4>{{ selectedIncident.title }}</h4>
        </div>
        <div class="col-12" *ngIf="selectedIncident.description">
            <p>{{ selectedIncident.description }}</p>
        </div>
        <div class="field col-6">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-check-circle"></i></p-inputgroup-addon>
                <p-iftalabel><p-dropdown inputId="editStatus" [options]="statuses" [(ngModel)]="selectedIncident.status"
                        styleClass="w-full" [appendTo]="'body'"></p-dropdown><label
                        for="editStatus">Status</label></p-iftalabel>
            </p-inputgroup>
        </div>
        <div class="field col-6">
            <p-inputgroup><p-inputgroup-addon><i class="pi pi-user"></i></p-inputgroup-addon>
                <p-iftalabel><p-dropdown inputId="editAssignedTo" [options]="users"
                        [(ngModel)]="selectedIncident.assignedTo" optionLabel="fullName" [showClear]="true"
                        styleClass="w-full" [appendTo]="'body'"></p-dropdown><label for="editAssignedTo">Assigned
                        To</label></p-iftalabel>
            </p-inputgroup>
        </div>
    </div>

    <p-divider align="left"><span class="font-bold">Comments</span></p-divider>

    <div class="flex flex-column gap-3 mt-3">
        <div *ngFor="let comment of selectedIncident.comments" class="flex gap-3">
            <p-avatar [image]="comment.commenter.profilePictureUrl || 'assets/default-avatar.png'"
                shape="circle"></p-avatar>
            <div class="flex-grow-1">
                <div class="font-bold">{{ comment.commenter.fullName }} <span
                        class="text-sm text-color-secondary ml-2">{{ comment.createdAt | date:'short' }}</span></div>
                <p>{{ comment.commentText }}</p>
            </div>
        </div>
        <div *ngIf="!selectedIncident.comments || selectedIncident.comments.length === 0"
            class="text-center text-color-secondary">No comments yet.</div>
    </div>

    <form [formGroup]="commentForm" (ngSubmit)="addComment()" class="mt-4">
        <div class="p-inputgroup">
            <input pInputText placeholder="Add a comment..." formControlName="commentText" />
            <button pButton type="submit" icon="pi pi-send" [disabled]="commentForm.invalid"></button>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" (click)="incidentDetailsDialogVisible = false"
            styleClass="p-button-text"></p-button>
        <p-button label="Save Changes" icon="pi pi-save" (click)="updateIncident()"></p-button>
    </ng-template>
</p-dialog>